import { Navigation, StopCircle, Headphones, Volume2, VolumeX, Subtitles } from "lucide-react";

const BANNER = "glass absolute left-1/2 top-[12rem] z-20 flex -translate-x-1/2 items-center gap-3 rounded-full py-1.5 pl-4 pr-1.5 text-xs font-semibold text-slate-700 sm:top-28";
const STOP = "flex items-center gap-1 rounded-full bg-slate-100 px-3 py-1 transition-colors hover:bg-slate-200";

export function GuideBanner({ target, tourStep, onStop }) {
  if (target) {
    return (
      <div data-testid="guided-banner" className={BANNER}>
        <Navigation className="h-4 w-4 text-cyan-600" /> {tourStep ? `Giro guidato · tappa ${tourStep.i + 1}/${tourStep.n} · ` : "Verso: "}{target.title}
        <button data-testid="guided-stop-btn" onClick={onStop} className={STOP}><StopCircle className="h-3.5 w-3.5" /> Stop</button>
      </div>
    );
  }
  if (!tourStep) return null;
  return (
    <div data-testid="tour-banner" className={BANNER}>
      <Headphones className="h-4 w-4 text-cyan-600" /> Giro guidato · Doctor Selvix sta parlando
      <button data-testid="tour-stop-btn" onClick={onStop} className={STOP}><StopCircle className="h-3.5 w-3.5" /> Interrompi</button>
    </div>
  );
}

export function VoiceControls({ subsOn, setSubsOn, narrator, showTour, onStartTour }) {
  return (
    <div className="absolute bottom-24 right-4 z-20 flex items-center gap-2 sm:bottom-auto sm:top-40">
      <button data-testid="subtitles-toggle" onClick={() => setSubsOn((v) => !v)} title={subsOn ? "Nascondi sottotitoli" : "Mostra sottotitoli"} className={`glass grid h-10 w-10 place-items-center rounded-full transition-colors ${subsOn ? "text-sky-700" : "text-slate-400"}`}>
        <Subtitles className="h-4 w-4" />
      </button>
      <button data-testid="tour-voice-toggle" aria-pressed={narrator.voiceOn} onClick={narrator.toggleVoice} title={narrator.voiceOn ? "Disattiva voce" : "Attiva voce"} className="glass flex h-10 items-center gap-1.5 rounded-full px-3 text-xs font-bold text-sky-700 transition-colors hover:text-sky-900">
        {narrator.voiceOn ? <Volume2 className="h-4 w-4" /> : <VolumeX className="h-4 w-4 text-slate-400" />}
        {!narrator.voiceOn && <span className="hidden sm:inline" data-testid="voice-muted-label">Attiva voce</span>}
      </button>
      {showTour && (
        <button data-testid="tour-start-btn" onClick={onStartTour} className="glass flex items-center gap-2 rounded-full px-4 py-2.5 text-xs font-bold text-sky-800 transition-colors hover:bg-white">
          <Headphones className="h-4 w-4" /> <span className="hidden sm:inline">Giro guidato parlato</span>
        </button>
      )}
    </div>
  );
}
